import React from 'react';
import _ from 'lodash';

import TaskEditorManualLegoExtraction from "./TaskEditorManualLegoExtraction";
import ManualFeaturesOilQuantityEditor from "./manuals-extraction/ManualFeaturesOilQuantityEditor";

export default class TaskEditorManualLegoOilQuantity extends TaskEditorManualLegoExtraction {
  constructor(props) {
    super(props);

    this.state.pdfInitialSearch = /(capacidad|cantidad|quantity|capacity)&&(motor|engine)&&(aceite|oil)&&\d\s?[,.]\s?\d/.source
  }

  renderExtractionControls() {
    let { files, file, fileHash, autosuggestions, autosuggestionsExplanation } = this.state;

    if (file) {
      return <ManualFeaturesOilQuantityEditor manual={file}
                                      key={fileHash + autosuggestions}
                                      initialChanges={autosuggestions}
                                      onSave={async (changedManual, legosUpdates, markTaskDone) => this.save(changedManual, legosUpdates, markTaskDone)}/>
    } else {
      return "No manual"
    }
  }
}
